export default {
    namespaced: true,
    state: {
        selectedItems: JSON.parse(
            localStorage.getItem("cubex_selected_items") || "[]"
        ),
        selectedUsers: JSON.parse(
            localStorage.getItem("cubex_selected_users") || "[]"
        )
    },
    mutations: {
        SET_SELECTED_ITEMS(state, items) {
            state.selectedItems = items;
            localStorage.setItem("cubex_selected_items", JSON.stringify(items));
        },
        CLEAR_SELECTED_ITEMS(state) {
            state.selectedItems = [];
            localStorage.removeItem("cubex_selected_items");
        },
        SET_SELECTED_USERS(state, users) {
            state.selectedUsers = users;
            localStorage.setItem("cubex_selected_users", JSON.stringify(users));
        },
        CLEAR_SELECTED_USERS(state) {
            state.selectedUsers = [];
            localStorage.removeItem("cubex_selected_users");
        }
    },
    actions: {
        setSelectedItems({ commit }, items) {
            commit("SET_SELECTED_ITEMS", items);
        },
        clearSelectedItems({ commit }) {
            commit("CLEAR_SELECTED_ITEMS");
        },
        setSelectedUsers({ commit }, users) {
            commit("SET_SELECTED_USERS", users);
        },
        clearSelectedUsers({ commit }) {
            commit("CLEAR_SELECTED_USERS");
        }
    },
    getters: {
        selectedItems: state => state.selectedItems,
        selectedUsers: state => state.selectedUsers
    }
};
